
export default {
  staticDomain: '//static.hsappstatic.net' || window.location.host,
  staticDomainPrefix: '//static.hsappstatic.net' || ('//' + window.location.host),
  currentProject: 'feedback-public-submission-ui',
  currentProjectVersion: 'static-1.30650',
  depVersions: {
  "feedback-public-submission-ui": "static-1.30650",
  "emoji-mart": "static-3.4",
  "feedback-schema": "static-1.55128",
  "head-dlb": "static-1.5007",
  "hs-test-utils": "static-1.8230",
  "hubspot-dlb": "static-2.1854",
  "HubStyleTokens": "static-2.11680",
  "I18n": "static-7.1650",
  "quartz": "static-1.7304",
  "quartz-config": "static-1.1082",
  "quartz-core": "static-1.6523",
  "react-dlb": "static-1.83",
  "react-dnd": "static-4.51",
  "react-dnd-html5-backend": "static-2.10",
  "redux-mock-store": "static-1.8",
  "redux-thunk": "static-2.43",
  "reselect": "static-3.8",
  "sinon": "static-1.9",
  "tinymce": "static-6.5",
  "cssUtils": "static-1.853",
  "enviro": "static-4.455",
  "feedback-shared-ui": "static-1.55115",
  "feedback-utils": "static-1.55119",
  "forms-embed-utils-lib": "static-1.4672",
  "forms-utils-lib": "static-1.12949",
  "foundations-assets": "static-1.5082",
  "foundations-components": "static-1.8315",
  "foundations-theming": "static-1.4649",
  "hub-http": "static-1.6423",
  "hubspot-url-utils": "static-1.4132",
  "HubStyle": "static-2.11987",
  "icons": "static-2.668",
  "immutable": "static-2.79",
  "quick-fetch": "static-1.4061",
  "raven": "static-3.5925",
  "react": "static-7.189",
  "react-dom": "static-7.85",
  "react-input-autosize": "static-2.17",
  "react-redux": "static-7.71",
  "react-rhumb": "static-1.16910",
  "react-select-plus": "static-1.108",
  "react-utils": "static-2.5484",
  "react-virtualized": "static-2.102",
  "redux": "static-4.16",
  "StyleGuideUI": "static-3.491",
  "tinymce-plugins": "static-1.58022",
  "transmute": "static-2.85",
  "ui-images": "static-2.1214",
  "UIComponents": "static-3.8626",
  "hs-promise-rejection-tracking": "static-1.5587",
  "PortalIdParser": "static-2.404",
  "raven-hubspot": "static-1.6232",
  "classnames": "static-2.10",
  "hoist-non-react-statics": "static-3.9",
  "metrics-js": "static-1.9637",
  "styled-components": "static-2.89",
  "bend-plugin-trellis-migration": "static-1.3543",
  "moment": "static-3.26",
  "bend-plugin-quartz": "static-1.3581",
  "quartz-webpack": "static-1.3528",
  "foundations-theming-specialty": "static-1.2365",
  "property-description-translator": "static-1.4046",
  "HeadJS": "static-2.782",
  "framer-motion": "static-1.75",
  "hs-test-utils-bend-plugin": "static-1.3341",
  "msw": "static-1.39",
  "testing-library": "static-1.155",
  "webpack-env": "static-1.54",
  "i18n-data": "static-1.225",
  "moment-timezone": "static-5.86",
  "jasmine": "static-4.4530",
  "jasmine-runner": "static-1.6660",
  "dispatcher": "static-1.140",
  "general-store": "static-6.20",
  "hub-http-janus": "static-1.858",
  "hubspotter-http": "static-1.4795",
  "mobile-manifest-mixins": "static-1.555",
  "module-federation": "static-1.29",
  "quartz-auth": "static-1.979",
  "quartz-head": "static-1.969",
  "quartz-i18n": "static-1.979",
  "quartz-routing": "static-1.734",
  "quartz-test": "static-1.979",
  "quartz-tracking": "static-1.683",
  "trellis-components": "static-1.2369",
  "ui-fonts": "static-1.942",
  "usage-tracker-container": "static-1-session-replay-endpoint-migration.6",
  "usage-tracker-core": "static-1-session-replay-endpoint-migration.6",
  "hs-lodash": "static-4.45",
  "sassPrefix": "static-1.160",
  "conversations-skeleton-state": "static-1.7454",
  "reference-resolvers": "static-1.8384",
  "sanitize-text": "static-1.8352",
  "PatternValidationJS": "static-1.3103",
  "ReduxMessenger": "static-2.10571",
  "sanitize": "static-1.4683",
  "outpost": "static-1.4371",
  "rpc-client-utils": "static-1.4864",
  "underscore": "static-1.8",
  "bend-plugin-foundations-components": "static-1.4584",
  "floating-ui": "static-1.60",
  "hs-story-utils": "static-1.9632",
  "react-aria": "static-1.69",
  "react-create-root-preference": "static-1.50",
  "tanstack-table": "static-1.58",
  "trellis-assets": "static-1.2350",
  "bend-plugin-foundations-theming": "static-1.3132",
  "foundations-theming-base": "static-1.3634",
  "stylex": "static-1.37",
  "hs-locale-management": "static-1.225",
  "csstype": "static-1.50",
  "web-vitals": "static-1.9",
  "ai-components-ui-library": "static-1.9468",
  "atom": "static-1.5282",
  "codemirror": "static-5.98",
  "content-assistance-lib": "static-1.8066",
  "ContentUtils": "static-1.68952",
  "data-token-picker": "static-1.16759",
  "file-manager-components": "static-1.24225",
  "FileManagerCore": "static-1.39724",
  "FileManagerLib": "static-1.39865",
  "frontend-preferences-client": "static-1.8132",
  "hub-http-contrib": "static-1.3247",
  "interframe": "static-3.4962",
  "layout-dnd-components": "static-1.12829",
  "layout-dnd-utils": "static-1.11804",
  "property-translator": "static-1.5602",
  "react-codemirror": "static-1.10847",
  "react-colorpicker": "static-2.10415",
  "reference-resolvers-lite": "static-1.8302",
  "rich-text-lib": "static-1.20177",
  "tinymce-data": "static-1.40993",
  "tinymce-themes": "static-1.56878",
  "ui-addon-emoji-picker": "static-1.10091",
  "ui-addon-sales-email": "static-1.5418",
  "ui-brand-identity-lib": "static-1.16031",
  "bender-build-tools": "static-1.3323",
  "hub-http-shared-msw-handlers": "static-1.10451",
  "hubspotter-http-shared-msw-handlers": "static-1.10449",
  "usage-tracker-session-replay": "static-1-session-replay-endpoint-migration.6",
  "base-ui": "static-1.17",
  "react-day-picker": "static-1.6",
  "trellis-theming": "static-1.1159",
  "tanstack-virtual": "static-1.33",
  "autolinker": "static-3.11",
  "bend-plugin-chirp-manifest": "static-1.274",
  "chirp-fetch": "static-1.2094",
  "chatspot-core": "static-1.22355",
  "copilot-toolkit": "static-1.11654",
  "customer-data-objects-ui-components": "static-1.13237",
  "data-fetching-client": "static-1.9864",
  "diff-match-patch": "static-1.7",
  "superstore": "static-1.4965",
  "ui-addon-video-player": "static-1.8912",
  "ui-coaching-tips": "static-1.29121",
  "usage-tracker": "static-1-session-replay-endpoint-migration.6",
  "cms-field-types": "static-1.5021",
  "content-icons-ui": "static-1.2290",
  "integrations-lib": "static-1.16793",
  "customer-data-objects": "static-1.7889",
  "apollo-dlb": "static-3.86",
  "breeze-engine-lib": "static-1.1439",
  "apollo-link-hub-http": "static-2.4860",
  "apollo-stack-hubspot": "static-3.89",
  "graphql": "static-1.85",
  "immer": "static-1.33",
  "immerable": "static-1.4354",
  "ui-addon-iframeable": "static-1.9280",
  "video-components-external": "static-1.11928",
  "video-data-lib": "static-1.35586",
  "audio-components": "static-1.6215",
  "cropperjs": "static-1.10",
  "feedback-loader": "static-1.29668",
  "FileManagerImages": "static-1.37376",
  "foundations-components-legacy": "static-1.1340",
  "html-to-image": "static-1.57",
  "react-immutable-proptypes": "static-2.8",
  "redux-toolkit": "static-1.7",
  "salesImages": "static-1.529",
  "ui-universal-auth": "static-1.9225",
  "urlinator": "static-1.4739",
  "video-components": "static-1.13930",
  "video-embed": "static-1.36420",
  "ts-schema": "static-1.4224",
  "ContentData": "static-1.69027",
  "layout-data-lib": "static-1.10129",
  "react-dnd-compat": "static-1.4820",
  "browser-eslint": "static-2.57",
  "batch-promise": "static-1.1750",
  "external-options-client-types": "static-1.4269",
  "fast-json-stable-stringify": "static-1.4",
  "framework-data-schema-resolvers": "static-1.7100",
  "hs-promise-utils": "static-1.5799",
  "inbound-db-properties-service-client": "static-1.3989",
  "NamespacedHubStyle": "static-2.9193",
  "growth-onboarding-confetti": "static-1.3267",
  "SharedI18nStrings": "static-1.182",
  "ui-addon-i18n": "static-1.11354",
  "amplitude-session-replay-browser": "static-1.60",
  "markdown-it": "static-1.6",
  "magpie-lib": "static-1.5697",
  "magpie-types": "static-1.5157",
  "simple-logging-lib": "static-1.3255",
  "avatar-components": "static-1.2703",
  "customer-data-ui-utilities": "static-1.10031",
  "growth-onboarding-feedback-components": "static-1.6788",
  "flux-actions": "static-1.355",
  "hubspot-apollo-client": "static-1.5083",
  "integrations-error-boundary-lib": "static-1.14208",
  "integrations-tracking-lib": "static-1.5813",
  "laboratory-lib": "static-3.7358",
  "native-integrations-shared-strings": "static-1.7983",
  "redux-observable": "static-1.11",
  "rxjs": "static-5.10",
  "ui-shepherd-react": "static-3.10467",
  "unified-auth": "static-1.739",
  "breeze-engine-chat-components": "static-1.417",
  "breeze-engine-core": "static-1.717",
  "ably": "static-2.2",
  "highlight.js": "static-1.82",
  "navigation-messaging": "static-1.7932",
  "content-media-composition-data-lib": "static-1.12977",
  "content-media-compositions": "static-2.16984",
  "idb-keyval": "static-1.47",
  "media-bridge-lib": "static-1.19274",
  "unified-auth-core-lib": "static-1.1021",
  "social-insights-client-types": "static-1.22598",
  "advanced-menus-core": "static-1.15454",
  "advanced-menus-lib": "static-1.12345",
  "ExportDialog": "static-6.10584",
  "ui-memberships-settings-lib": "static-1.34613",
  "conditional-properties-service-client": "static-1.3940",
  "crm-pipelines-api-client-types": "static-1.4280",
  "fdsr-migration-layer": "static-1.219",
  "framework-builder-read-service-client": "static-1.4149",
  "framework-data-schema-quick-fetch": "static-1.7005",
  "inbound-db-meta-service-client": "static-1.3718",
  "multi-currency-client-types": "static-1.3834",
  "persist-promise": "static-1.3907",
  "foundations-components-test-utils": "static-1.5798",
  "reactive-lib": "static-1.928",
  "react-immutable-render-mixin": "static-1.9",
  "hubspot-apollo-cache": "static-1.542",
  "universal-page-editor-lib": "static-1.3217",
  "adobe-sign-auth-lib": "static-1.255",
  "ads-unified-auth-lib": "static-1.785",
  "google-sheets-integration-lib": "static-1.833",
  "microsoft-drive-integration-lib": "static-1.943",
  "surveymonkey-integration-lib": "static-1.277",
  "slack-ui-library": "static-1.10605",
  "js-cookie": "static-1.18",
  "fsm": "static-1.3938",
  "seamless-immutable": "static-7.6",
  "simple-menus-core": "static-1.15453",
  "simple-menus-lib": "static-1.16970",
  "crm-record-cards-service-types": "static-1.3727",
  "location-customization-utils-lib": "static-1.9879",
  "react-flip-move": "static-1.74"
},
  depPathPrefixes: {
  "feedback-public-submission-ui": "/feedback-public-submission-ui/static-1.30650",
  "emoji-mart": "/emoji-mart/static-3.4",
  "feedback-schema": "/feedback-schema/static-1.55128",
  "head-dlb": "/head-dlb/static-1.5007",
  "hs-test-utils": "/hs-test-utils/static-1.8230",
  "hubspot-dlb": "/hubspot-dlb/static-2.1854",
  "HubStyleTokens": "/HubStyleTokens/static-2.11680",
  "I18n": "/I18n/static-7.1650",
  "quartz": "/quartz/static-1.7304",
  "quartz-config": "/quartz-config/static-1.1082",
  "quartz-core": "/quartz-core/static-1.6523",
  "react-dlb": "/react-dlb/static-1.83",
  "react-dnd": "/react-dnd/static-4.51",
  "react-dnd-html5-backend": "/react-dnd-html5-backend/static-2.10",
  "redux-mock-store": "/redux-mock-store/static-1.8",
  "redux-thunk": "/redux-thunk/static-2.43",
  "reselect": "/reselect/static-3.8",
  "sinon": "/sinon/static-1.9",
  "tinymce": "/tinymce/static-6.5",
  "cssUtils": "/cssUtils/static-1.853",
  "enviro": "/enviro/static-4.455",
  "feedback-shared-ui": "/feedback-shared-ui/static-1.55115",
  "feedback-utils": "/feedback-utils/static-1.55119",
  "forms-embed-utils-lib": "/forms-embed-utils-lib/static-1.4672",
  "forms-utils-lib": "/forms-utils-lib/static-1.12949",
  "foundations-assets": "/foundations-assets/static-1.5082",
  "foundations-components": "/foundations-components/static-1.8315",
  "foundations-theming": "/foundations-theming/static-1.4649",
  "hub-http": "/hub-http/static-1.6423",
  "hubspot-url-utils": "/hubspot-url-utils/static-1.4132",
  "HubStyle": "/HubStyle/static-2.11987",
  "icons": "/icons/static-2.668",
  "immutable": "/immutable/static-2.79",
  "quick-fetch": "/quick-fetch/static-1.4061",
  "raven": "/raven/static-3.5925",
  "react": "/react/static-7.189",
  "react-dom": "/react-dom/static-7.85",
  "react-input-autosize": "/react-input-autosize/static-2.17",
  "react-redux": "/react-redux/static-7.71",
  "react-rhumb": "/react-rhumb/static-1.16910",
  "react-select-plus": "/react-select-plus/static-1.108",
  "react-utils": "/react-utils/static-2.5484",
  "react-virtualized": "/react-virtualized/static-2.102",
  "redux": "/redux/static-4.16",
  "StyleGuideUI": "/StyleGuideUI/static-3.491",
  "tinymce-plugins": "/tinymce-plugins/static-1.58022",
  "transmute": "/transmute/static-2.85",
  "ui-images": "/ui-images/static-2.1214",
  "UIComponents": "/UIComponents/static-3.8626",
  "hs-promise-rejection-tracking": "/hs-promise-rejection-tracking/static-1.5587",
  "PortalIdParser": "/PortalIdParser/static-2.404",
  "raven-hubspot": "/raven-hubspot/static-1.6232",
  "classnames": "/classnames/static-2.10",
  "hoist-non-react-statics": "/hoist-non-react-statics/static-3.9",
  "metrics-js": "/metrics-js/static-1.9637",
  "styled-components": "/styled-components/static-2.89",
  "bend-plugin-trellis-migration": "/bend-plugin-trellis-migration/static-1.3543",
  "moment": "/moment/static-3.26",
  "bend-plugin-quartz": "/bend-plugin-quartz/static-1.3581",
  "quartz-webpack": "/quartz-webpack/static-1.3528",
  "foundations-theming-specialty": "/foundations-theming-specialty/static-1.2365",
  "property-description-translator": "/property-description-translator/static-1.4046",
  "HeadJS": "/HeadJS/static-2.782",
  "framer-motion": "/framer-motion/static-1.75",
  "hs-test-utils-bend-plugin": "/hs-test-utils-bend-plugin/static-1.3341",
  "msw": "/msw/static-1.39",
  "testing-library": "/testing-library/static-1.155",
  "webpack-env": "/webpack-env/static-1.54",
  "i18n-data": "/i18n-data/static-1.225",
  "moment-timezone": "/moment-timezone/static-5.86",
  "jasmine": "/jasmine/static-4.4530",
  "jasmine-runner": "/jasmine-runner/static-1.6660",
  "dispatcher": "/dispatcher/static-1.140",
  "general-store": "/general-store/static-6.20",
  "hub-http-janus": "/hub-http-janus/static-1.858",
  "hubspotter-http": "/hubspotter-http/static-1.4795",
  "mobile-manifest-mixins": "/mobile-manifest-mixins/static-1.555",
  "module-federation": "/module-federation/static-1.29",
  "quartz-auth": "/quartz-auth/static-1.979",
  "quartz-head": "/quartz-head/static-1.969",
  "quartz-i18n": "/quartz-i18n/static-1.979",
  "quartz-routing": "/quartz-routing/static-1.734",
  "quartz-test": "/quartz-test/static-1.979",
  "quartz-tracking": "/quartz-tracking/static-1.683",
  "trellis-components": "/trellis-components/static-1.2369",
  "ui-fonts": "/ui-fonts/static-1.942",
  "usage-tracker-container": "/usage-tracker-container/static-1-session-replay-endpoint-migration.6",
  "usage-tracker-core": "/usage-tracker-core/static-1-session-replay-endpoint-migration.6",
  "hs-lodash": "/hs-lodash/static-4.45",
  "sassPrefix": "/sassPrefix/static-1.160",
  "conversations-skeleton-state": "/conversations-skeleton-state/static-1.7454",
  "reference-resolvers": "/reference-resolvers/static-1.8384",
  "sanitize-text": "/sanitize-text/static-1.8352",
  "PatternValidationJS": "/PatternValidationJS/static-1.3103",
  "ReduxMessenger": "/ReduxMessenger/static-2.10571",
  "sanitize": "/sanitize/static-1.4683",
  "outpost": "/outpost/static-1.4371",
  "rpc-client-utils": "/rpc-client-utils/static-1.4864",
  "underscore": "/underscore/static-1.8",
  "bend-plugin-foundations-components": "/bend-plugin-foundations-components/static-1.4584",
  "floating-ui": "/floating-ui/static-1.60",
  "hs-story-utils": "/hs-story-utils/static-1.9632",
  "react-aria": "/react-aria/static-1.69",
  "react-create-root-preference": "/react-create-root-preference/static-1.50",
  "tanstack-table": "/tanstack-table/static-1.58",
  "trellis-assets": "/trellis-assets/static-1.2350",
  "bend-plugin-foundations-theming": "/bend-plugin-foundations-theming/static-1.3132",
  "foundations-theming-base": "/foundations-theming-base/static-1.3634",
  "stylex": "/stylex/static-1.37",
  "hs-locale-management": "/hs-locale-management/static-1.225",
  "csstype": "/csstype/static-1.50",
  "web-vitals": "/web-vitals/static-1.9",
  "ai-components-ui-library": "/ai-components-ui-library/static-1.9468",
  "atom": "/atom/static-1.5282",
  "codemirror": "/codemirror/static-5.98",
  "content-assistance-lib": "/content-assistance-lib/static-1.8066",
  "ContentUtils": "/ContentUtils/static-1.68952",
  "data-token-picker": "/data-token-picker/static-1.16759",
  "file-manager-components": "/file-manager-components/static-1.24225",
  "FileManagerCore": "/FileManagerCore/static-1.39724",
  "FileManagerLib": "/FileManagerLib/static-1.39865",
  "frontend-preferences-client": "/frontend-preferences-client/static-1.8132",
  "hub-http-contrib": "/hub-http-contrib/static-1.3247",
  "interframe": "/interframe/static-3.4962",
  "layout-dnd-components": "/layout-dnd-components/static-1.12829",
  "layout-dnd-utils": "/layout-dnd-utils/static-1.11804",
  "property-translator": "/property-translator/static-1.5602",
  "react-codemirror": "/react-codemirror/static-1.10847",
  "react-colorpicker": "/react-colorpicker/static-2.10415",
  "reference-resolvers-lite": "/reference-resolvers-lite/static-1.8302",
  "rich-text-lib": "/rich-text-lib/static-1.20177",
  "tinymce-data": "/tinymce-data/static-1.40993",
  "tinymce-themes": "/tinymce-themes/static-1.56878",
  "ui-addon-emoji-picker": "/ui-addon-emoji-picker/static-1.10091",
  "ui-addon-sales-email": "/ui-addon-sales-email/static-1.5418",
  "ui-brand-identity-lib": "/ui-brand-identity-lib/static-1.16031",
  "bender-build-tools": "/bender-build-tools/static-1.3323",
  "hub-http-shared-msw-handlers": "/hub-http-shared-msw-handlers/static-1.10451",
  "hubspotter-http-shared-msw-handlers": "/hubspotter-http-shared-msw-handlers/static-1.10449",
  "usage-tracker-session-replay": "/usage-tracker-session-replay/static-1-session-replay-endpoint-migration.6",
  "base-ui": "/base-ui/static-1.17",
  "react-day-picker": "/react-day-picker/static-1.6",
  "trellis-theming": "/trellis-theming/static-1.1159",
  "tanstack-virtual": "/tanstack-virtual/static-1.33",
  "autolinker": "/autolinker/static-3.11",
  "bend-plugin-chirp-manifest": "/bend-plugin-chirp-manifest/static-1.274",
  "chirp-fetch": "/chirp-fetch/static-1.2094",
  "chatspot-core": "/chatspot-core/static-1.22355",
  "copilot-toolkit": "/copilot-toolkit/static-1.11654",
  "customer-data-objects-ui-components": "/customer-data-objects-ui-components/static-1.13237",
  "data-fetching-client": "/data-fetching-client/static-1.9864",
  "diff-match-patch": "/diff-match-patch/static-1.7",
  "superstore": "/superstore/static-1.4965",
  "ui-addon-video-player": "/ui-addon-video-player/static-1.8912",
  "ui-coaching-tips": "/ui-coaching-tips/static-1.29121",
  "usage-tracker": "/usage-tracker/static-1-session-replay-endpoint-migration.6",
  "cms-field-types": "/cms-field-types/static-1.5021",
  "content-icons-ui": "/content-icons-ui/static-1.2290",
  "integrations-lib": "/integrations-lib/static-1.16793",
  "customer-data-objects": "/customer-data-objects/static-1.7889",
  "apollo-dlb": "/apollo-dlb/static-3.86",
  "breeze-engine-lib": "/breeze-engine-lib/static-1.1439",
  "apollo-link-hub-http": "/apollo-link-hub-http/static-2.4860",
  "apollo-stack-hubspot": "/apollo-stack-hubspot/static-3.89",
  "graphql": "/graphql/static-1.85",
  "immer": "/immer/static-1.33",
  "immerable": "/immerable/static-1.4354",
  "ui-addon-iframeable": "/ui-addon-iframeable/static-1.9280",
  "video-components-external": "/video-components-external/static-1.11928",
  "video-data-lib": "/video-data-lib/static-1.35586",
  "audio-components": "/audio-components/static-1.6215",
  "cropperjs": "/cropperjs/static-1.10",
  "feedback-loader": "/feedback-loader/static-1.29668",
  "FileManagerImages": "/FileManagerImages/static-1.37376",
  "foundations-components-legacy": "/foundations-components-legacy/static-1.1340",
  "html-to-image": "/html-to-image/static-1.57",
  "react-immutable-proptypes": "/react-immutable-proptypes/static-2.8",
  "redux-toolkit": "/redux-toolkit/static-1.7",
  "salesImages": "/salesImages/static-1.529",
  "ui-universal-auth": "/ui-universal-auth/static-1.9225",
  "urlinator": "/urlinator/static-1.4739",
  "video-components": "/video-components/static-1.13930",
  "video-embed": "/video-embed/static-1.36420",
  "ts-schema": "/ts-schema/static-1.4224",
  "ContentData": "/ContentData/static-1.69027",
  "layout-data-lib": "/layout-data-lib/static-1.10129",
  "react-dnd-compat": "/react-dnd-compat/static-1.4820",
  "browser-eslint": "/browser-eslint/static-2.57",
  "batch-promise": "/batch-promise/static-1.1750",
  "external-options-client-types": "/external-options-client-types/static-1.4269",
  "fast-json-stable-stringify": "/fast-json-stable-stringify/static-1.4",
  "framework-data-schema-resolvers": "/framework-data-schema-resolvers/static-1.7100",
  "hs-promise-utils": "/hs-promise-utils/static-1.5799",
  "inbound-db-properties-service-client": "/inbound-db-properties-service-client/static-1.3989",
  "NamespacedHubStyle": "/NamespacedHubStyle/static-2.9193",
  "growth-onboarding-confetti": "/growth-onboarding-confetti/static-1.3267",
  "SharedI18nStrings": "/SharedI18nStrings/static-1.182",
  "ui-addon-i18n": "/ui-addon-i18n/static-1.11354",
  "amplitude-session-replay-browser": "/amplitude-session-replay-browser/static-1.60",
  "markdown-it": "/markdown-it/static-1.6",
  "magpie-lib": "/magpie-lib/static-1.5697",
  "magpie-types": "/magpie-types/static-1.5157",
  "simple-logging-lib": "/simple-logging-lib/static-1.3255",
  "avatar-components": "/avatar-components/static-1.2703",
  "customer-data-ui-utilities": "/customer-data-ui-utilities/static-1.10031",
  "growth-onboarding-feedback-components": "/growth-onboarding-feedback-components/static-1.6788",
  "flux-actions": "/flux-actions/static-1.355",
  "hubspot-apollo-client": "/hubspot-apollo-client/static-1.5083",
  "integrations-error-boundary-lib": "/integrations-error-boundary-lib/static-1.14208",
  "integrations-tracking-lib": "/integrations-tracking-lib/static-1.5813",
  "laboratory-lib": "/laboratory-lib/static-3.7358",
  "native-integrations-shared-strings": "/native-integrations-shared-strings/static-1.7983",
  "redux-observable": "/redux-observable/static-1.11",
  "rxjs": "/rxjs/static-5.10",
  "ui-shepherd-react": "/ui-shepherd-react/static-3.10467",
  "unified-auth": "/unified-auth/static-1.739",
  "breeze-engine-chat-components": "/breeze-engine-chat-components/static-1.417",
  "breeze-engine-core": "/breeze-engine-core/static-1.717",
  "ably": "/ably/static-2.2",
  "highlight.js": "/highlight.js/static-1.82",
  "navigation-messaging": "/navigation-messaging/static-1.7932",
  "content-media-composition-data-lib": "/content-media-composition-data-lib/static-1.12977",
  "content-media-compositions": "/content-media-compositions/static-2.16984",
  "idb-keyval": "/idb-keyval/static-1.47",
  "media-bridge-lib": "/media-bridge-lib/static-1.19274",
  "unified-auth-core-lib": "/unified-auth-core-lib/static-1.1021",
  "social-insights-client-types": "/social-insights-client-types/static-1.22598",
  "advanced-menus-core": "/advanced-menus-core/static-1.15454",
  "advanced-menus-lib": "/advanced-menus-lib/static-1.12345",
  "ExportDialog": "/ExportDialog/static-6.10584",
  "ui-memberships-settings-lib": "/ui-memberships-settings-lib/static-1.34613",
  "conditional-properties-service-client": "/conditional-properties-service-client/static-1.3940",
  "crm-pipelines-api-client-types": "/crm-pipelines-api-client-types/static-1.4280",
  "fdsr-migration-layer": "/fdsr-migration-layer/static-1.219",
  "framework-builder-read-service-client": "/framework-builder-read-service-client/static-1.4149",
  "framework-data-schema-quick-fetch": "/framework-data-schema-quick-fetch/static-1.7005",
  "inbound-db-meta-service-client": "/inbound-db-meta-service-client/static-1.3718",
  "multi-currency-client-types": "/multi-currency-client-types/static-1.3834",
  "persist-promise": "/persist-promise/static-1.3907",
  "foundations-components-test-utils": "/foundations-components-test-utils/static-1.5798",
  "reactive-lib": "/reactive-lib/static-1.928",
  "react-immutable-render-mixin": "/react-immutable-render-mixin/static-1.9",
  "hubspot-apollo-cache": "/hubspot-apollo-cache/static-1.542",
  "universal-page-editor-lib": "/universal-page-editor-lib/static-1.3217",
  "adobe-sign-auth-lib": "/adobe-sign-auth-lib/static-1.255",
  "ads-unified-auth-lib": "/ads-unified-auth-lib/static-1.785",
  "google-sheets-integration-lib": "/google-sheets-integration-lib/static-1.833",
  "microsoft-drive-integration-lib": "/microsoft-drive-integration-lib/static-1.943",
  "surveymonkey-integration-lib": "/surveymonkey-integration-lib/static-1.277",
  "slack-ui-library": "/slack-ui-library/static-1.10605",
  "js-cookie": "/js-cookie/static-1.18",
  "fsm": "/fsm/static-1.3938",
  "seamless-immutable": "/seamless-immutable/static-7.6",
  "simple-menus-core": "/simple-menus-core/static-1.15453",
  "simple-menus-lib": "/simple-menus-lib/static-1.16970",
  "crm-record-cards-service-types": "/crm-record-cards-service-types/static-1.3727",
  "location-customization-utils-lib": "/location-customization-utils-lib/static-1.9879",
  "react-flip-move": "/react-flip-move/static-1.74"
}
};
